/**
 * Clear query control for Funnelback search forms.
 */
import { useState, useEffect, type KeyboardEvent } from 'react';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';

type Props = {
  baseClassName: string;
  searchTerm: string;
  onClear: () => void;
};

const ClearButton = (props: Props) => {
  const { baseClassName, searchTerm, onClear } = props;
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    setShowButton(searchTerm.length > 0);
  }, [searchTerm]);

  const handleKeyDown = (e: KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClear();
    }
  };

  return showButton ? (
    <button
      type="button"
      name="button-clear"
      className={`${baseClassName}__clear-button`}
      onClick={onClear}
      onKeyDown={handleKeyDown}
      aria-label="Clear search"
    >
      <CloseSharpIcon />
    </button>
  ) : null;
};

export default ClearButton;
